import { render } from "./MyReferrals.vue?vue&type=template&id=54988ab3&scoped=true"
import script from "./MyReferrals.vue?vue&type=script&lang=js"
export * from "./MyReferrals.vue?vue&type=script&lang=js"

import "./MyReferrals.vue?vue&type=style&index=0&id=54988ab3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54988ab3"]])

export default __exports__